<template>
  <div class="mt-2">
    <fcc-table
      striped
      hover
      responsive
      :items="sistemas"
      :fields="fields"
      :optionsButton="options"
      :actions="actions"
      pagination
    />

    <fccModal
      idModal="modal-sistema"
      :titleModal="titleModal"
      centered
      escondeFooter
      @close="limparForm"
    >
      <b-form @submit.prevent="salvar" autocomplete="off"
        ><div class="row mb-4">
          <div class="col">
            <fcc-select :options="tiposSistema" v-model="form.tipoSistema" required
              >Tipo de Sistema</fcc-select
            >
          </div>
        </div>
        <div class="row mb-4">
          <div class="col"><fcc-input v-model="form.descricao" required>Descrição</fcc-input></div>
        </div>

        <div class="row text-right">
          <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
        </div></b-form
      >
    </fccModal>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import { acaoConstantes } from '../constants'
import axios from 'axios'

export default {
  data() {
    return {
      itemSelecionado: null,
      form: { tipoSistema: null, descricao: '' },
      acaoModal: acaoConstantes.ADICIONAR,
      fields: [
        { key: 'idsistema', label: 'ID', sortable: true },
        { key: 'descricao', label: 'Descriçao', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      options: [
        {
          funcaoButton: 'adicionar',
          text: 'Adicionar',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['sistemas', 'tiposSistema']),
    titleModal() {
      return this.acaoModal === acaoConstantes.ADICIONAR ? 'Adicionar Sistema' : 'Editar Sistema'
    }
  },
  mounted() {
    this.atualizarItens()
  },
  methods: {
    limparForm() {
      this.form = { tipoSistema: null, descricao: '' }
    },
    atualizarItens() {
      store
        .dispatch('acompanhamentoDeProjetos/fetchSistemas', this.dadosLoginSession.fccTokenHeaders)
        .then(() =>
          store.dispatch(
            'acompanhamentoDeProjetos/fetchTiposSistema',
            this.dadosLoginSession.fccTokenHeaders
          )
        )
        .then(() => this.$emit('carregado'))
        .catch(this.setErrorSystem)
    },
    adicionar() {
      this.acaoModal = acaoConstantes.ADICIONAR
      this.$root.$emit('bv::show::modal', 'modal-sistema')
    },
    editField(_, item) {
      this.itemSelecionado = item
      this.form.tipoSistema = this.tiposSistema.find((tipo) => tipo.tpsistema === item.tpsistema)
      this.form.descricao = item.descricao
      this.acaoModal = acaoConstantes.EDITAR
      this.$root.$emit('bv::show::modal', 'modal-sistema')
    },
    deleteField(_, item) {
      this.callConfirm('Deseja excluir o sistema?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.sistemaExcluir(item.idsistema)
            .then(() => {
              this.carregaTexto()
              this.atualizarItens()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    salvar() {
      this.callConfirm(
        this.acaoModal === acaoConstantes.ADICIONAR
          ? 'Deseja adicionar um sistema?'
          : 'Deseja editar o sistema?',
        ''
      ).then((result) => {
        if (result.value) {
          const methodTipoSistema =
            this.acaoModal === acaoConstantes.ADICIONAR
              ? this.sistemaAdicionar
              : this.sistemaAlterar

          this.carregaTexto(this.codeMensagem('C01'))
          methodTipoSistema()
            .then(() => {
              this.carregaTexto()
              this.limparForm()
              this.atualizarItens()
              this.$root.$emit('bv::hide::modal', 'modal-sistema')
              this.acaoModal === acaoConstantes.ADICIONAR
                ? this.callToast(this.mensagensUpdate.adicionado)
                : this.callToast(this.mensagensUpdate.editado, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    sistemaAdicionar() {
      const payload = {
        tpSistema: this.form.tipoSistema.tpsistema,
        idSistema: 0,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.post(
        store.state.baseUrlGestaoProjetos + 'SistemasFcc/Adicionar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    sistemaAlterar() {
      const payload = {
        tpSistema: this.form.tipoSistema.tpsistema,
        idSistema: this.itemSelecionado.idsistema,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.put(
        store.state.baseUrlGestaoProjetos + 'SistemasFcc/Alterar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    sistemaExcluir(idSistema) {
      return axios.delete(
        store.state.baseUrlGestaoProjetos + 'SistemasFcc/Excluir/' + idSistema,
        this.dadosLoginSession.fccTokenHeaders
      )
    }
  }
}
</script>